import React from "react";
import { useT } from "@/context/I18nContext";
import { Link } from "react-router-dom";
import { PhoneCall, LifeBuoy, MessageSquareHeart } from "lucide-react";

export default function Safety() {
  const t = useT();
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-16" data-testid="page-safety">
      <header className="mb-8">
        <h1 className="font-heading text-3xl md:text-5xl tracking-tight text-ink-900">
          {t("public.safety.title")}
        </h1>
        <p className="mt-3 text-ink-500 text-base md:text-lg max-w-2xl">
          {t("public.safety.subtitle")}
        </p>
      </header>

      <section className="rounded-3xl bg-white shadow-card p-6 md:p-8 mb-6 border-l-4 border-terracotta-500" data-testid="safety-crisis">
        <div className="flex items-center gap-2 mb-2">
          <PhoneCall className="h-5 w-5 text-terracotta-500" strokeWidth={1.75} />
          <h2 className="font-heading text-xl">{t("public.safety.crisis.heading")}</h2>
        </div>
        <p className="text-sm md:text-base text-ink-700 leading-relaxed mb-3">
          {t("public.safety.crisis.body")}
        </p>
        <ul className="list-disc pl-5 text-sm md:text-base text-ink-700 space-y-1.5">
          <li>{t("public.safety.crisis.eu")}</li>
          <li>{t("public.safety.crisis.nl113")}</li>
          <li>{t("public.safety.crisis.samaritans")}</li>
        </ul>
      </section>

      <section className="rounded-3xl bg-white shadow-card p-6 md:p-8 mb-6" data-testid="safety-what-we-do">
        <div className="flex items-center gap-2 mb-2">
          <MessageSquareHeart className="h-5 w-5 text-sage-600" strokeWidth={1.75} />
          <h2 className="font-heading text-xl">{t("public.safety.whatwedo.heading")}</h2>
        </div>
        <p className="text-sm md:text-base text-ink-700 leading-relaxed mb-3">
          {t("public.safety.whatwedo.body")}
        </p>
        <ul className="list-disc pl-5 text-sm md:text-base text-ink-700 space-y-1.5">
          <li>{t("public.safety.whatwedo.emergency")}</li>
          <li>{t("public.safety.whatwedo.helplines")}</li>
          <li>{t("public.safety.whatwedo.consent")}</li>
        </ul>
      </section>

      <section className="rounded-3xl bg-white shadow-card p-6 md:p-8" data-testid="safety-limits">
        <div className="flex items-center gap-2 mb-2">
          <LifeBuoy className="h-5 w-5 text-sage-600" strokeWidth={1.75} />
          <h2 className="font-heading text-xl">{t("public.safety.limits.heading")}</h2>
        </div>
        <p className="text-sm md:text-base text-ink-700 leading-relaxed">
          {t("public.safety.limits.body")}
        </p>
        <div className="mt-4">
          <Link
            to="/contact"
            data-testid="safety-cta-contact"
            className="inline-flex items-center rounded-full bg-sage-500 hover:bg-sage-600 text-white px-5 py-2 text-sm"
          >
            {t("public.safety.cta")}
          </Link>
        </div>
      </section>
    </div>
  );
}
